import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import flutter from "../Images/flutter.png";
import reactLogo from "../Images/react.png";
import node1 from "../Images/node.png";
import mongo from "../Images/mongo.png";
import sql from "../Images/sql.png";
import js from "../Images/js.png";
import java from "../Images/java.png";
import python from "../Images/python.png";
import dotnet from "../Images/dotnet.png";
import angular from "../Images/angular.png";
import powerBi from "../Images/pbi.png";
import tableau from "../Images/tableau.png";
import seo from "../Images/seo.png";
import wordpress from "../Images/wpress.png";
import git from "../Images/git.png";
import aws from "../Images/aws.png";

const courses = [
  { name: "Flutter", img: flutter },
  { name: "React", img: reactLogo },
  { name: "Node.js", img: node1 },
  { name: "MongoDB", img: mongo },
  { name: "SQL", img: sql },
  { name: "JavaScript", img: js },
  { name: "Java", img: java },
  { name: "Python", img: python },
  { name: ".NET", img: dotnet },
  { name: "Angular", img: angular },
  { name: "Power BI", img: powerBi },
  { name: "Tableau", img: tableau },
  { name: "SEO", img: seo },
  { name: "WordPress", img: wordpress },
  { name: "Git", img: git },
  { name: "AWS", img: aws },
];

const CourseCard = ({ name, img }) => (
  <motion.div
    className="course1-card"
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.95 }}
    initial={{ opacity: 0, y: 50 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7 }}
  >
    <div className="course1-inner">
      <img src={img} alt={name} className="course1-img" />
      <p className="course1-name">{name}</p>
    </div>
  </motion.div>
);

const Courses = () => {
  return (
    <Container className="py-5 text-center">
      <h2 className="fw-bold mb-4" style={{ color: "white" }}>🚀 Our Technologies</h2>
      <Row className="g-4 justify-content-center">
        {courses.map((course, index) => (
          <Col key={index} xs={6} sm={4} md={3} lg={2}>
            <CourseCard name={course.name} img={course.img} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Courses;
